import React from 'react';

const HackathonCTA2: React.FC = () => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 py-12">
      <style>
        {`
          @keyframes scalePulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
          .scale-pulse {
            animation: scalePulse 1.5s ease-in-out infinite;
            display: block;
            font-size: 3rem;
            margin: 0 auto 1rem;
          }
          @media (max-width: 768px) {
            .scale-pulse {
              opacity: 0.7;
            }
          }
          @keyframes gradient-x {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .animate-gradient-x {
            animation: gradient-x 15s ease infinite;
            background-size: 200% 200%;
          }
        `}
      </style>
      <div className="relative">
        {/* Glow effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-yellow-500 rounded-2xl blur opacity-50 group-hover:opacity-70 transition duration-1000 group-hover:duration-200 animate-gradient-x"></div>
        
        <div className="relative bg-cyan-500 rounded-2xl shadow-lg overflow-hidden border border-cyan-500">
          <div className="p-8 md:p-12">
            <div className="max-w-2xl mx-auto text-center space-y-8">
              <div>
                <span className="scale-pulse">⭐️</span>
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Star Our Repo on GitHub!
                </h2>
              </div>
              <p className="text-lg text-slate-200">
                Show your support. Every star helps us grow and improve!
              </p>
              <div className="flex justify-center">
                <a
                  href="https://github.com/StructuredLabs/preswald"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-3 bg-yellow-50 text-slate-900 border-2 border-yellow-100 hover:bg-yellow-100 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 font-medium w-fit"
                >
                  Star on GitHub
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HackathonCTA2; 